const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let loaderPromise;

export const googleMapsConfigured = Boolean(apiKey);
export const googleMapId = process.env.REACT_APP_GOOGLE_MAP_ID || 'DEMO_MAP_ID';

export function loadGoogleMaps() {
  if (!apiKey) return Promise.reject(new Error('google_maps_not_configured'));
  if (window.google?.maps?.importLibrary) return Promise.resolve(window.google.maps);
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    const callback = '__nidoGoogleMapsReady';
    window[callback] = () => {
      delete window[callback];
      resolve(window.google.maps);
    };

    const script = document.createElement('script');
    const params = new URLSearchParams({
      key: apiKey,
      loading: 'async',
      callback,
      v: 'weekly',
      language: 'es',
      region: 'AR',
      auth_referrer_policy: 'origin',
    });
    script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
    script.async = true;
    script.onerror = () => {
      delete window[callback];
      loaderPromise = null;
      reject(new Error('google_maps_load_failed'));
    };
    document.head.appendChild(script);
  });

  return loaderPromise;
}

export async function importGoogleLibrary(name) {
  const maps = await loadGoogleMaps();
  return maps.importLibrary(name);
}
